import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './pwa'; // side-effect: capture beforeinstallprompt early
import App from './App';
import ErrorBoundary from './ErrorBoundary';
import { ToastProvider } from './Toast';
import { ThemeProvider } from './Theme';
import { register as registerServiceWorker } from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <ThemeProvider>
      <ToastProvider>
        <App />
      </ToastProvider>
    </ThemeProvider>
  </ErrorBoundary>
);

// Register the service worker; it auto-applies new builds when backgrounded.
registerServiceWorker();
